<template>

  <div class="linkButton">
    <div v-if="this.mdIconNameEdit" class="material-icons forIconEdit text-success"> {{this.mdIconNameEdit}} </div>
    <a class="text-primary" @click="GoToRoute">
      {{this.linkTextEdit}}
    </a>
  </div>

</template> 
  
<script> 
  
  export default {
    name: "RouterLinkButton",
    components: {
    }, 
    data(){
      return{
        isMounted : false,
        linkTextEdit:null,
        mdIconNameEdit:null,
      }
    },
    props: {
      mdIconName:String,
      mode:String,
      linkText:String,
      routeName:String,
      routeParams:Object
    },
    created(){ // called BEFORE rendering (load data here)

    },
    mounted() { // called afer rendering
      this.isMounted = true; 
      this.mdIconNameEdit = this.mdIconName;
      this.routeNameEdit = this.routeName; 
      this.linkTextEdit = this.linkText; 

      if(this.mode == "backButton"){
        if(this.mdIconName == null)
          this.mdIconNameEdit = "arrow_back_ios_new"; 
        if(this.linkText == null)
          this.linkTextEdit = "Go Back";
      }
    },

    methods:{
      GoToRoute(){
        //console.log("router button going to ");
        if(this.mode == "backButton"){
          this.$router.go(-1);
        }
        else if(this.routeName != null)
          this.$router.push({ name: this.routeName, params: this.routeParams });
      }
    },
    unmounted(){ //called when the page is left or the component is destroyed

      //console.log("force update user contracts table"); 
      this.$forceUpdate();
    }
  }
</script>
  
<style scoped>
.linkButton{
    display:flex;
    margin-bottom:15px;
  }
</style>
